import { barChart } from "../../../images";
import { Heading, Text } from "../../common";
import classes from "./DeployService.module.css";
import clsx from "clsx";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

const DeployService = () => {
  return (
    <section className={classes.wrapper}>
      <Swiper
        loop={true}
        navigation={false}
        slidesPerView={1}
        effect={"fade"}
        autoplay={{
          delay: 3000, // Delay between slides (in ms)
          disableOnInteraction: false, // Keep autoplay running even after user interaction
        }}
        pagination={{
          clickable: true,
          renderBullet: function (index, className) {
            return `<span class="${className} custom-dot"></span>`;
          },
        }}
        modules={[Pagination, Autoplay]} // Include Autoplay module
        scrollbar={{ hide: true }}
        className={clsx("collections-swiper", classes.swiper)}
      >
        {/* Add your slides */}
        {[1, 2, 3].map((slide) => (
          <SwiperSlide key={slide}>
            <div className={clsx(classes.card)}>
              <Heading lg primary semiBold textCenter>
                Deploy your services
              </Heading>
              <div className={classes.container}>
                <img src={barChart} alt="#" className={classes.img} />
                <div className={classes.features}>
                  <Text xs textWhite className={classes.feature}>
                    10+ Networks
                  </Text>
                  <Text xs textWhite className={classes.feature}>
                    99% less cost
                  </Text>
                  <Text xs textWhite className={classes.feature}>
                    100% uptime
                  </Text>
                </div>
                <Heading xl font600 textCenter>
                  100TB+ of Historic data
                </Heading>
                <Text base secondary textCenter>
                  Our Database has 100+ TB of queriable history data for easy
                  blockchain research and verification
                </Text>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default DeployService;
